<template>
    <ModalDefaultInner
        v-model="showDefaultModal"
        :modal-data="successModalData"
        @cta="action"
        size="md"
    >
        <template #icon>
            <CardIcon type="success">
                <CheckIcon />
            </CardIcon>
        </template>
    </ModalDefaultInner>
</template>

<script>
// TODO: for now there is no confetti
// import confetti from "@/shared/js/confetti";
import { CardIcon } from "@easy/ui/cards";
import { CheckIcon } from "@easy/ui/icons";
import { ModalDefaultInner } from "@easy/ui/modals";

export default {
    components: {
        ModalDefaultInner,
        CardIcon,
        CheckIcon,
    },
    data() {
        return {
            showDefaultModal: false,
            successModalData: {
                title: this.modalData.title,
                description: this.modalData.desc,
                ctaLabel: this.modalData.actionBtn,
            },
        };
    },
    props: {
        modalData: Object,
    },
    mounted() {
        // confetti.start(5000);
    },
    methods: {
        action() {
            this.modalData.callback();
            this.$emit("close");
        },
    },
};
</script>
